<template>
  <div id="user_comment">
    <div class="bgc-white bdrs10 u-shadow-bottom">
      <p class="ta-c p20 fw-b fz150 bb-black50">ユーザーコメント</p>

      <div>

       <div class="ptb15 plr20" v-show="!commented">
          <div class="d-f ai-c">
            <span class="fw-b fz105">コメントを書く</span>
            <span class="d-ib">
              <div class="js-tippyTooltip">
                <div class="hov js-tippyTooltip-button" aria-expanded="false">
                  <i class="u-icon-question-fill"></i>
                </div>
                <div class="js-tippyTooltip-content">
                  <div class="tippy-content-inner -black">
                    <div class="d-b lh140 fw-b c-white fz85 p10" style="width: 300px;">
                      <span class="d-b">コメントを書くにあたって、以下を一読ください。<br>
                        ・コメントは、あとから編集できません。<br>
                        ・特定の個人名を入れないでください。<br>
                        ・誹謗中傷のコメントを入れないでください。
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </div>

          <div v-if="myNickname" class="pt10 d-f gap10">
          <p>ニックネーム：<span class="fw-b">{{ myNickname }}</span></p>
          <a :href="`/person/my_page/assessment_result/edit?return_to=${encodeURIComponent(currentPath + '#user_comment')}`" class="hov"><i class="u-icon-status-pen"></i></a>
          </div>
          <textarea name="body" rows="6" class="u-input-textarea mt15" placeholder="【投稿前にご一読ください】投稿後は編集不可です。また個人名・誹謗中傷はお控えください。" v-model="commentText" @input="handleInput" ref="bodyInput"></textarea>
          <p class="error-txt" v-show="!isValid">コメントを入力してください</p>
          <button type="button" class="u-reset-button c-white bdrs-max p15 fw-b fz115 lh100 w-max ta-c hov mt15 mb15" :class="isValid && !nowSending ? 'bgc-key' : 'bgc-black50'" :disabled="!isValid && nowSending" @click="postComment">{{nowSending ? '送信中です' : 'コメントを登録する'}}</button>
        </div>

        <div class="bt-black50" data-comment-id="1" v-for="(comment, index) in comments" :key="comment.id">
          <div class="plr20 pt20">
            <div class="d-f jc-sb ai-c">
              <div class="d-if ai-c gap5 lh130">
                <i class="u-icon-comment-user fz200 "></i>
                <p class="fw-b"><span class="c-black50 fz75">ニックネーム：</span><br><span class="fz105">{{ comment.nickname }}</span>
                <a v-if="comment.its_mine" :href="`/person/my_page/assessment_result/edit?return_to=${encodeURIComponent(currentPath + '#user_comment')}`" class="hov"><i class="u-icon-status-pen"></i></a>
                </p>
              </div>
              <div v-if="myComment && myComment.id === comment.id">
                <button type="button" class="u-reset-button hov js-modalToggle" data-modal="deleteComment"><i class="u-icon-delete"></i></button>
              </div>
              <div v-if="(!myComment || myComment.id !== comment.id) && !!matchingScores[comment.user_id]">
                <div class="d-f ai-c jc-c gap5 u-box-GradationOverlay">
                  <div class="bdrs-max plr10 bd-black100 d-f ai-c jc-c gap5">
                    <span class="fz85 lh100 fw-b">性格マッチ度</span>
                    <span class="d-ib">
                      <div class="js-tippyTooltip">
                        <div class="hov js-tippyTooltip-button" aria-expanded="false">
                          <i class="u-icon-question-fill"></i>
                        </div>
                        <div class="js-tippyTooltip-content">
                          <div class="tippy-content-inner -black">
                            <div class="d-b lh140 fw-b c-white fz85 p10" style="width: 300px;">
                              <span class="d-b">あなたとの性格・特性（自己分析の結果）との近さを%で表しています</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div class="fw-b">
                    <span class="fz175">{{ matchingScores[comment.user_id].score_integer }}</span><span>.{{ matchingScores[comment.user_id].score_decimal }}%</span>
                  </div>
                </div>
              </div>
              <div v-else-if="!myComment || myComment.id !== comment.id"><div class="u-skelton-line" style="width: 60px;"></div></div>
            </div>
            <div class="mt10">
              <p class="lh160" style="white-space: pre-wrap; word-break: break-word;">{{ comment.body }}</p>
              <p class="ta-r mt5 c-black50">{{ comment.format_created_at }}</p>
            </div>
          </div>
          <div class="mt20 d-f ai-c gap5 sm-plr5 plr20 pb10">
            <label class="u-reset-button f1 d-if jc-sb ai-c fw-b bdrs-max plr15 sm-plr10 ptb10 lh100 fz90 ta-c hov bgc-black20" :class="comment.checked_helpful ? 'bgc-blue15 bd-blue c-blue' : 'bgc-black20'">
              <input type="checkbox" name="helpful" class="d-n" :checked="comment.checked_helpful" @change="handleRatingChange(index, 'checked_helpful', $event), postRating(index, comment.id, $event)">
              <span>😆役に立った</span>
              <span>{{ comment.rating_helpful_count }}</span>
            </label>
            <label class="u-reset-button f1 d-if jc-sb ai-c fw-b bdrs-max plr15 sm-plr10 ptb10 lh100 fz90 ta-c hov bgc-black20" :class="comment.checked_informative ? 'bgc-blue15 bd-blue c-blue' : 'bgc-black20'">
              <input type="checkbox" name="informative" class="d-n" :checked="comment.checked_informative" @change="handleRatingChange(index, 'checked_informative', $event), postRating(index, comment.id, $event)">
              <span>😲なるほど</span>
              <span>{{ comment.rating_informative_count }}</span>
            </label>
            <label class="u-reset-button f1 d-if jc-sb ai-c fw-b bdrs-max plr15 sm-plr10 ptb10 lh100 fz90 ta-c hov bgc-black20" :class="comment.checked_unhelpful ? 'bgc-blue15 bd-blue c-blue' : 'bgc-black20'">
              <input type="checkbox" name="unhelpful" class="d-n" :checked="comment.checked_unhelpful" @change="handleRatingChange(index, 'checked_unhelpful', $event), postRating(index, comment.id, $event)">
              <span>☹️うーん</span>
              <span>{{ comment.rating_unhelpful_count }}</span>
            </label>
          </div>
        </div>

   
      </div>
    </div>

    <div class="js-modalWrap u-modal-wrap" data-modal="deleteComment">
      <div class="u-modal-wrap-view">
        <div class="u-modal-wrap-main p30 sm-p20">
          <p class="fw-b ta-c fz165">このコメントを削除</p>
          <p class="fz115 fw-b ta-c mt20">本当に削除してもよろしいですか？<br>
            ※この操作は取り消せません。</p>
          <button type="button" class="mt30 u-reset-button bgc-red fw-b c-white ta-c w-max bdrs10 p15 fz135 hov js-modalClose" @click="deleteComment">削除する</button>
        </div>
      </div>
      <div class="js-modalClose u-modal-wrap-back"></div>
    </div>
  </div>
</template>

<script>
import { popupSuccess, popupError } from '@/packs/person/popup';

export default {
  props: {
    propAnalysisCode: String,
    propComments: Array,
    propMyComment: {
      type: Object,
      default: () => ({}),
    },
    propCommented: Boolean,
    propMyNickname: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      analysisCode: null,
      comments: [],
      myComment: {},
      commented: false,
      myNickname: '',
      commentText: '',
      isValid: true,
      nowSending: false,
      matchingScores: {},
      currentPath: window.location.pathname,
    }
  },
  created() {
    this.analysisCode = this.propAnalysisCode;
    this.comments = this.propComments;
    this.myComment = this.propMyComment;
    this.commented = this.propCommented;
    this.myNickname = this.propMyNickname;

    this.comments.forEach(({ user_id, its_mine }) => {
      if (!its_mine) {
        this.getMathingScore(user_id);
      }
    });
  },
  watch: {
  },
  methods: {
    pathRating(analysisCode, commentId) {
      return `/person/ajax/my_page/ai_company_analyses/${analysisCode}/comment/${commentId}/rating`;
    },
    pathPostComment() {
      return `/person/ajax/my_page/ai_company_analyses/${this.analysisCode}/comment`;
    },
    pathDeleteComment() {
      return `/person/ajax/my_page/ai_company_analyses/${this.analysisCode}/comment/${this.myComment?.id}`;
    },
    pathGetMatchingScore(userId) {
      return `/person/ajax/my_page/user_matching_rate?user_id=${userId}`;
    },
    handleRatingChange(index, checked_key, event) {
      const comment = this.comments[index];
      if (comment.its_mine) {
        event.target.checked = !event.target.checked;
        popupError('コメントした本人はリアクションできません');
        return;
      }
      const isChecking = event.target.checked;
      const keyToCount = {
        checked_helpful: 'rating_helpful_count',
        checked_informative: 'rating_informative_count',
        checked_unhelpful: 'rating_unhelpful_count',
      };

      Object.keys(keyToCount).forEach((key) => {
        if (comment[key] && key !== checked_key) {
          this.$set(comment, key, false);
          this.$set(comment, keyToCount[key], comment[keyToCount[key]] - 1);
        }
      });

      this.$set(comment, checked_key, isChecking);
      this.$set(comment, keyToCount[checked_key], comment[keyToCount[checked_key]] + (isChecking ? 1 : -1));
    },
    handleInput() {
      this.isValid = this.commentText.trim() !== '';
    },
    // コメントの評価を送信する
    async postRating(index, commentId, event) {
      if (this.comments[index].its_mine) return;
      if (this.nowSending) return;

      this.nowSending = true;
      const res = await fetch(this.pathRating(this.analysisCode, commentId), {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ rating: event.target.name, checked: event.target.checked }),
      });

      if (res.ok) {
        const data = await res.json();
        Object.entries(data.rating_counts).forEach(([key, value]) => {
          this.$set(this.comments[index], key, value);
        });
      }
    },
    // コメントを送信
    async postComment() {
      if (this.nowSending) return;

      this.isValid = this.$refs.bodyInput.value.trim() !== '';
      if (this.isValid) {
        this.nowSending = true;
        const res = await fetch(this.pathPostComment(), {
          method: 'POST',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ body: this.commentText }),
        });
        this.nowSending = false;

        if (res.ok) {
          const data = await res.json();
          this.comments.unshift(data.prop_comment);
          if (data.comment) {
            this.myComment = data.comment;
          }
          this.commented = true;
          popupSuccess('コメントを追加しました');
        } else {
          const data = await res.json().catch(() => null);
          const message = data?.message || 'エラーが発生しました';
          popupError(message);
        }
      }
    },
    // コメントを削除する
    async deleteComment() {
      if (this.nowSending) return;

      this.nowSending = true;
      const res = await fetch(this.pathDeleteComment(), {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
      });
      this.nowSending = false;

      if (res.ok) {
        const data = await res.json();
        this.comments = this.comments.filter((comment) => comment.id !== data.comment.id);
        this.myComment = null;
        this.commented = false;
        popupSuccess('コメントを削除しました');
      } else {
        popupError('エラーが発生しました');
      }
    },
    // コメントしたユーザーとのマッチ度を取得
    async getMathingScore(userId) {
      const res = await fetch(this.pathGetMatchingScore(userId));
      const score = await res.json();
      this.$set(this.matchingScores, userId, score);
    }
  },
}
</script>

